import type { FC, SVGProps } from 'react'

export const Autotune: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8833 5.39099C14.7302 5.8195 14.4408 6.28736 14.1025 6.73992C18.1982 7.69187 21.25 11.3645 21.25 15.7499C21.25 16.1642 21.5858 16.4999 22 16.4999C22.4142 16.4999 22.75 16.1642 22.75 15.7499C22.75 10.8116 19.4202 6.65106 14.8833 5.39099ZM9.89755 6.73992C9.55917 6.28735 9.26984 5.8195 9.11672 5.39099C4.57984 6.65106 1.25 10.8116 1.25 15.7499C1.25 16.1642 1.58579 16.4999 2 16.4999C2.41421 16.4999 2.75 16.1642 2.75 15.7499C2.75 11.3645 5.80182 7.69187 9.89755 6.73992Z"
      fill="currentColor"
      fillOpacity="0.4"
    />
    <path
      d="M15 4.8C15 6.3464 12 9 12 9C12 9 9 6.3464 9 4.8C9 3.2536 10.3431 2 12 2C13.6569 2 15 3.2536 15 4.8Z"
      fill="currentColor"
    />
    <circle cx="12" cy="16" r="3" fill="currentColor" />
  </svg>
)
